import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-95026953"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "nge-stage-body" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-stage-who" }, "Nurro", -1 /* HOISTED */))
const _hoisted_4 = { class: "nge-stage-text" }
const _hoisted_5 = {
  key: 0,
  class: "nge-stage-icons"
}
const _hoisted_6 = ["title"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "nge-stage-actions" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Transition, { name: "nge-stage-card" }, {
    default: _withCtx(() => [
      ($setup.announcement)
        ? (_openBlock(), _createElementBlock("div", {
            key: $setup.announcement.at,
            class: "ng-extend nge-stage-card",
            role: "status",
            "aria-live": "polite"
          }, [
            _createElementVNode("img", {
              src: $setup.imgNurro,
              alt: "",
              class: "nge-stage-nurro"
            }, null, 8 /* PROPS */, _hoisted_1),
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("p", _hoisted_4, _toDisplayString($setup.announcement.text), 1 /* TEXT */),
              ($setup.icons.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.icons, (d) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: d.id,
                        class: "nge-stage-icon",
                        title: d.label
                      }, [
                        (d.svg)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              innerHTML: d.svg
                            }, null, 8 /* PROPS */, _hoisted_7))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(d.emoji), 1 /* TEXT */)
                            ], 64 /* STABLE_FRAGMENT */))
                      ], 8 /* PROPS */, _hoisted_6))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  class: "nge-hud-btn nge-stage-ok",
                  onClick: $setup.close
                }, "Got it"),
                ($setup.announcement.settingsButton)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "nge-hud-btn nge-hud-btn--quiet nge-stage-settings",
                      onClick: $setup.openSettings
                    }, "Profile Settings"))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}